var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3835 19.3666H18.6835M12.3835 22.0666H15.5335M13.7335 15.3166L17.3335 11.7166M17.3335 15.3166L13.7335 11.7166M21.8335 7.66663H9.2335C8.9948 7.66663 8.76588 7.76145 8.5971 7.93023C8.42832 8.09901 8.3335 8.32793 8.3335 8.56663V24.7666C8.3335 25.0053 8.42832 25.2342 8.5971 25.403C8.76588 25.5718 8.9948 25.6666 9.2335 25.6666H21.8335C22.0722 25.6666 22.3011 25.5718 22.4699 25.403C22.6387 25.2342 22.7335 25.0053 22.7335 24.7666V8.56663C22.7335 8.32793 22.6387 8.09901 22.4699 7.93023C22.3011 7.76145 22.0722 7.66663 21.8335 7.66663Z",
    stroke: "#FBFDFD",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/leave.7d417f5b1f61b183c05f6741e71ab3b9.svg";
export { ForwardRef as ReactComponent };